// src/pages/feedback/components/FeedbackStatusChip.tsx
//
// 상태 칩 — filled soft 규격. StatusChip.tsx(컨테이너 임대)와 완전히 같은
// 치수·형태(h22 · r6 · 1px 보더 · 6px 도트 · 11.5px/600)를 쓴다.
// 색은 feedbackVisuals.ts 가 단일 소스다.

import { Box } from "@mui/material";
import { designTokens } from "../../../theme.ts";
import type { FeedbackStatus } from "../../../contracts/feedback/types";
import { statusVisual } from "./feedbackVisuals.ts";

const T = designTokens;

interface FeedbackStatusChipProps {
  status: FeedbackStatus;
  size?: "small" | "medium";
  sx?: any;
}

export default function FeedbackStatusChip({
  status,
  size = "small",
  sx,
}: FeedbackStatusChipProps) {
  const v = statusVisual(status);

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        height: size === "small" ? 22 : 26,
        px: 0.85,
        borderRadius: "6px",
        border: `1px solid ${v.border}`,
        bgcolor: v.bg,
        color: v.fg,
        fontFamily: T.fonts.sans,
        fontWeight: 600,
        fontSize: size === "small" ? 11.5 : 12.5,
        lineHeight: 1,
        letterSpacing: 0,
        whiteSpace: "nowrap",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: v.dot ?? v.fg,
          flexShrink: 0,
        }}
      />
      {v.ko}
    </Box>
  );
}
